<div class="project-context" dropdown>
  <span *ngIf="isBroker || this.dsUserTenantMap.length <= 1" class="text-lg company-name"> <i
      class="fa fa-industry"></i> {{businessEntityName}}</span>

  <span *ngIf="!isBroker && this.dsUserTenantMap.length > 1" class="margin-top-5">
    <dx-select-box placeholder="Choose Market" [dataSource]="dsUserTenantMap" displayExpr="tenantName"
      valueExpr="tenantId" hint="Choose market" [value]="tenantId" [readOnly]="false" [searchEnabled]="false"
      (onValueChanged)="onTenantChanged($event)">
    </dx-select-box>
  </span>
</div>